import * as L from 'leaflet';
import first from 'lodash/first';
import last from 'lodash/last';
import { Marker } from 'react-leaflet';
import type { ILinkDetails } from '../../../../../../../../../models/link-details.model';
import { LabelType } from '../../models/label-type.enum';
import LabelHelper from '../../../helpers/label.helper';

function DestinationLinkLabelMarker({ link, labelType }: { link: ILinkDetails; labelType: LabelType }) {
  const coordinate = labelType === LabelType.departure ? first(link.linkCoordinates) : last(link.linkCoordinates);
  const vericalAnchorPoint = labelType === LabelType.departure ? -3 : 29;
  const time = labelType === LabelType.departure ? link.plannedDepartureTime : link.plannedArrivalTime;
  const timeString = time ? time.toFormat('HH:mm') : undefined;

  if (!coordinate) {
    return null;
  }

  const icon = L.divIcon({
    className: 'destination-link-label w-auto h-auto',
    html: LabelHelper.createIconHtml(link.transportMode, timeString, undefined, false),
    iconAnchor: [-10, vericalAnchorPoint],
  });

  return <Marker icon={icon} position={[coordinate.latitude, coordinate.longitude]} />;
}

export default DestinationLinkLabelMarker;
